// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "5686e56fc10f142ce3cc12259f0a9c9e091ac8b5/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"41":"a0ec33ed","440":"486bdddc","581":"a474c96c","788":"2ee88f8e","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};